import { render, staticRenderFns } from "./AppDepartmentFactsContactsBlock.vue?vue&type=template&id=551f612a"
import script from "./AppDepartmentFactsContactsBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentFactsContactsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports